import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { topics } from '@/mocks/movies';

export default function TopicCollections() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="COLLECTIONS"
          title="影视专题合集"
          description="围绕主题策划的作品清单，一次看个够。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {topics.slice(0, 3).map((topic) => (
            <Link
              key={topic.id}
              to={`/topic/${topic.id}`}
              className="group relative block overflow-hidden rounded-lg border border-background-200"
            >
              <div className="relative h-56 w-full overflow-hidden bg-background-200">
                <img
                  src={topic.cover}
                  alt={`${topic.title} 专题封面`}
                  title={topic.title}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/45 to-transparent" />
              </div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="text-[11px] uppercase tracking-[0.2em] text-accent-400">{topic.subtitle}</span>
                <h3 className="mt-1.5 font-heading text-lg font-bold text-background-50">{topic.title}</h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-background-200">{topic.description}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-background-50">
                  查看专题
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}